import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Field, TextInput, TextArea } from "../site/formPrimitives";
import { Save } from "lucide-react";

const FIELDS = [
  ["address", "Adresse", "textarea"],
  ["phone", "Telefonnummer", "text"],
  ["email", "E-postadresse", "text"],
  ["hours", "Åpningstider", "textarea"],
  ["org_number", "Organisasjonsnummer", "text"],
  ["maps_link", "Google Maps-lenke", "text"],
  ["instagram", "Instagram-lenke", "text"],
  ["tiktok", "TikTok-lenke", "text"],
  ["google_reviews_link", "Lenke til Google-anmeldelser", "text"],
];

export default function ContactAdmin() {
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/content/contact").then((r) => setForm(r.data || {})).catch(() => {}); }, []);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    setSaving(true);
    try {
      const { id, ...payload } = form;
      await api.put("/admin/contact", payload);
      toast.success("Kontaktinformasjon lagret");
    } catch (e) {
      toast.error("Kunne ikke lagre");
    } finally { setSaving(false); }
  };

  return (
    <div data-testid="admin-contact">
      <h1 className="font-heading text-2xl font-bold text-navy">Kontaktinformasjon</h1>
      <p className="mt-1 text-sm text-ink/60">Tomme felt vises ikke på nettstedet.</p>

      <div className="mt-6 max-w-2xl rounded-xl border border-hairline bg-white p-5 sm:p-6 shadow-sm space-y-4">
        {FIELDS.map(([key, label, type]) => (
          <Field key={key} label={label}>
            {type === "textarea" ? (
              <TextArea value={form[key] || ""} onChange={(e) => set(key, e.target.value)} data-testid={`contact-${key}`} />
            ) : (
              <TextInput value={form[key] || ""} onChange={(e) => set(key, e.target.value)} data-testid={`contact-${key}`} />
            )}
          </Field>
        ))}
        <button onClick={save} disabled={saving} className="inline-flex items-center gap-2 rounded-full bg-warm px-6 py-3 text-sm font-semibold text-navy hover:bg-warm-dark disabled:opacity-50" data-testid="contact-save">
          <Save className="h-4 w-4" /> {saving ? "Lagrer ..." : "Lagre"}
        </button>
      </div>
    </div>
  );
}
